import localforage from 'localforage';
localforage.config({ name: 'files' });

const localforageExtended = {
  removeItem: async (key) => await localforage.removeItem(key),
  getItem: async (key) => await localforage.getItem(key),
};

export default localforageExtended;
